import styled from '@emotion/styled';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const BarcodeScanner = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2rem;
	width: 60%;
`;

export const InfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
`;

export const Divider = styled.div`
	border-right: 1px solid var(--border-color);
	margin: 0 var(--margin-2);
	height: 3rem;
`;

export const ShippingSuccessCard = styled(Card)`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
`;

export const ShippingSuccessInfoCard = styled(Card)`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	flex: 0 0 auto;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		margin: var(--margin-4) 0 !important;
	}
`;
